export default {
  namespaced: true,
  state: {
    config: {
      apiUrl: 'https://mc3.sqzw.com/release/mc3/api/?app_act=webopen',
    },
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    // 系统配置
    getSysConfig: async function ({state}, payload) {
      let result = await this.$http.get('/api/config')
      console.log('getSysConfig', result)
    }
  }
}
